/*
 * @Author: guang
 * @Date: 2020-12-09 11:46:28
 * @LastEditTime: 2020-12-10 09:04:12
 * @LastEditors: guang
 * @Description:
 */

// eslint-disable-next-line
const echarts = equire([
    // 写上你需要的
    'bar'
])

export default echarts
